export enum DonorAction {
    Edit = 1,
    Remove = 2
}